// Step 3 Validation - Ensure buttons enable correctly for step 3
(function() {
  'use strict';

  function validateStep3() {
    var form = $('#auction-form');
    if (form.length === 0) {
      return false; // Not on step 3
    }

    var isValid = true;
    var immediateSelected = $('#immediate_sale_ad').is(':checked');
    var scheduledSelected = $('#scheduled_sale_ad').is(':checked');

    // Check for date validation errors in notice divs
    var hasDateErrors = false;
    var noticeSelectors = [
      "#auction_publication_date_notice",
      "#scheduled_date_notice",
      "#auction_notice_publication_date_notice",
      "#auction_notice_auction_date_notice",
      "#auction_minimum_maximum_increase_notice"
    ];

    noticeSelectors.forEach(function(selector) {
      if ($(selector).find('.alert-warning').length > 0) {
        hasDateErrors = true;
      }
    });

    // Check for has-error classes
    var hasErrorClasses = form.find('.has-error').length > 0;

    // Check mandatory fields
    var mandatoryFields = form.find('.mandatory_field:visible');
    var allMandatoryFilled = true;

    mandatoryFields.each(function() {
      var field = $(this);

      // Skip disabled fields
      if (field.prop('disabled') || field.prop('readonly')) {
        return;
      }

      // Special handling for publication_date_and_time when "Immediately" is selected
      if (field.attr('name') === 'auction[publication_date_and_time]' && immediateSelected) {
        return;
      }

      var value = field.val();
      var isEmpty = false;

      // Check if field is empty
      if (field.attr('type') === 'number') {
        // For number fields, check if it's empty or placeholder
        if (value === '' || value === null || value === undefined || value === 'HH' || value === 'MM') {
          isEmpty = true;
        }
      } else {
        // For other fields
        value = (value || '').toString().trim();
        isEmpty = (value === '' || value === 'HH' || value === 'MM');
      }

      if (isEmpty) {
        allMandatoryFilled = false;
      }
    });

    // Check display times if display_time_info section is visible
    var displayTimeSection = $('#display_time_info');
    if (displayTimeSection.length > 0 && !displayTimeSection.hasClass('hide')) {
      var hasDisplayTimes = displayTimeSection.find('.nested-fields').length > 0;
      if (hasDisplayTimes) {
        displayTimeSection.find('.nested-fields').each(function() {
          var displayTime = $(this);
          var displayDate = displayTime.find('.display_date').val() || '';
          var startHour = displayTime.find('input[name*="[start_hour]"]').val();
          var startMinute = displayTime.find('input[name*="[start_minute]"]').val();
          var endHour = displayTime.find('input[name*="[end_hour]"]').val();
          var endMinute = displayTime.find('input[name*="[end_minute]"]').val();

          // Convert to strings and clean up
          displayDate = displayDate ? displayDate.toString().trim() : '';
          startHour = (startHour !== null && startHour !== undefined && startHour !== '') ? startHour.toString().trim() : '';
          startMinute = (startMinute !== null && startMinute !== undefined && startMinute !== '') ? startMinute.toString().trim() : '';
          endHour = (endHour !== null && endHour !== undefined && endHour !== '') ? endHour.toString().trim() : '';
          endMinute = (endMinute !== null && endMinute !== undefined && endMinute !== '') ? endMinute.toString().trim() : '';

          // Remove placeholder values
          if (startHour === 'HH') startHour = '';
          if (startMinute === 'MM') startMinute = '';
          if (endHour === 'HH') endHour = '';
          if (endMinute === 'MM') endMinute = '';

          // Check if numeric values are valid (including 0)
          var startHourValid = startHour !== '' && startHour !== 'HH' && !isNaN(parseFloat(startHour)) && isFinite(startHour);
          var startMinuteValid = startMinute !== '' && startMinute !== 'MM' && !isNaN(parseFloat(startMinute)) && isFinite(startMinute);
          var endHourValid = endHour !== '' && endHour !== 'HH' && !isNaN(parseFloat(endHour)) && isFinite(endHour);
          var endMinuteValid = endMinute !== '' && endMinute !== 'MM' && !isNaN(parseFloat(endMinute)) && isFinite(endMinute);

          // If any field is filled, all must be filled
          if (displayDate || startHourValid || startMinuteValid || endHourValid || endMinuteValid) {
            if (!displayDate || !startHourValid || !startMinuteValid || !endHourValid || !endMinuteValid) {
              allMandatoryFilled = false;
              return false; // break the loop
            }
          }
        });
      }
    }

    // Check for time validation errors (end time must be > start time)
    if ($("#auction_display_date_notice").find('.alert-warning').length > 0) {
      hasDateErrors = true;
    }

    // For "Immediately" selected, check if publication_date is filled (if it exists)
    // Note: For sales_ad, publication_date might not exist, which is OK
    if (immediateSelected) {
      var publicationDate = form.find('input[name="auction[publication_date]"]');
      if (publicationDate.length > 0 && publicationDate.is(':visible') && !publicationDate.prop('disabled')) {
        var pubDateVal = publicationDate.val();
        if (!pubDateVal || pubDateVal.trim() === '') {
          allMandatoryFilled = false;
        }
      }
      if (mandatoryFields.length === 0 || (mandatoryFields.length === 1 && mandatoryFields.first().attr('name') === 'auction[publication_date_and_time]' && mandatoryFields.first().prop('disabled'))) {
        allMandatoryFilled = true; // No mandatory fields to fill, so it's valid
      }
    }
    
    // Check for disableattchmentbutton class, but don't let it block validation if everything else is valid
    // The class might be set by date validation, but if dates are now valid, we should enable the button
    var hasDisableClass = form.find('button.checkMandatory').hasClass('disableattchmentbutton');
    
    // Only consider disableattchmentbutton as invalid if there are actual date errors
    // If there are no date errors and all fields are filled, remove the class and enable buttons
    if (allMandatoryFilled && !hasDateErrors && !hasErrorClasses && hasDisableClass) {
      // Everything is valid but button has disable class - remove it
      form.find('button.checkMandatory').removeClass('disableattchmentbutton');
      hasDisableClass = false;
    }

    isValid = allMandatoryFilled && !hasDateErrors && !hasErrorClasses && !hasDisableClass;

    // Enable/disable buttons - FORCE enable if valid
    form.find('button.checkMandatory[type="submit"]').each(function() {
      var button = $(this);
      if (isValid) {
        button.prop('disabled', false);
        button.removeClass('disabled');
        button.removeClass('disableattchmentbutton');
        button.css({
          'pointer-events': 'auto',
          'opacity': '1',
          'cursor': 'pointer'
        });
      } else {
        button.prop('disabled', true);
        button.addClass('disabled');
      }
    });

    return isValid;
  }

  // Run validation on page load
  $(document).ready(function() {
    setTimeout(validateStep3, 500);
    setTimeout(validateStep3, 1500);
  });

  // Run validation when fields change
  $(document).on('change input keyup', '#auction-form .mandatory_field', function() {
    setTimeout(validateStep3, 100);
  });

  // Run validation when date changes
  $(document).on('change changeDate', '#auction-form .datepicker', function() {
    setTimeout(validateStep3, 150);
    setTimeout(validateStep3, 400);
  });

  // Run validation when display time fields change
  $(document).on('change input keyup', '#display_time_info .mandatory_field', function() {
    setTimeout(validateStep3, 100);
    setTimeout(validateStep3, 300);
  });

  // Run validation when immediate/scheduled radio changes
  $(document).on('click', '#immediate_sale_ad, #scheduled_sale_ad', function() {
    setTimeout(validateStep3, 200);
  });

  // Run validation VERY frequently to catch all changes
  setInterval(function() {
    if ($('#auction-form').length > 0) {
      validateStep3();
    }
  }, 500); // Every 500ms

  // Also validate when display_date changes (for when date is selected after times)
  $(document).on('changeDate change', '#display_time_info .display_date', function() {
    setTimeout(validateStep3, 100);
    setTimeout(validateStep3, 300);
    setTimeout(validateStep3, 600);
  });

  // Expose globally
  window.validateStep3 = validateStep3;
})();

